export const GET_USER_ORDER_HISTORY = 'GET_USER_ORDER_HISTORY'
export const UPDATE_USER_ORDER_HISTORY = 'UPDATE_USER_ORDER_HISTORY'
export const SAVE_FAVORITE_ORDER = 'SAVE_FAVORITE_ORDER'
export const REMOVE_FAVORITE_ORDER = 'REMOVE_FAVORITE_ORDER'
